import * as React from 'react'
import CircularProgress from 'material-ui-next/Progress/CircularProgress'
import injectSheet from 'react-jss'
import {layers} from '../Style'

const styles = {
    root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        position: 'fixed',
        zIndex: layers.middle,
        top: 0,
    }
}

export const FullScreenLoader =
    injectSheet(styles)(
        () => (
            <div className="fs-loader">
                <CircularProgress
                    size={60}
                    thickness={6}
                />
            </div>
        ),
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/FullScreenLoader.tsx